export class ProductCost {
  public customerPrice = 0.0;
  public dealerPrice = 0.0;

  public amount = 0;
}
